import {useNavigate, useParams} from 'react-router-dom';
import styled from '@emotion/styled/macro';
import Button from '../../common/button/Button';
import FormField from '../../common/formField/FormField';
import { useUserContext } from '../../../context/userContext';

const Form = styled.form`
    width: 100%;

    & > label {
        margin-bottom: 1rem;
    }
    & > label:last-of-type {
      margin-bottom: 0;
    }

    & button {
        margin-top: 32px;
    }
  .buttons {
    display: flex;
    flex-direction:row;
    justify-content: space-around;
    gap: 10px;
    > * {
      flex-grow: 1;
    }
`

const ButtonDiv = styled.div`
    display: flex;
      flex-direction: row;
      align-items: center;
      
      justify-content: space-around;
`

const AccountFound: React.FC<{onCompleteLogin: (communityId:string) => void}> = (props) => {
    const { onCompleteLogin } = props;
    const navigate = useNavigate();
    const { user } = useUserContext();

    const { communityId } = useParams();
    if (communityId === undefined) throw "Community missing!";
    const handleSubmit = (event: React.FormEvent) => {
        event.preventDefault();
        onCompleteLogin(communityId);
    }

    return (
        <Form onSubmit={handleSubmit}>
            <FormField
                label="First Name"
                name="firstName"
                type="text"
                value={user?.firstName || ''}
            />
            <FormField
                label="Last Name"
                name="lastName"
                type="text"
                value={user?.lastName || ''}
            />
            <FormField
                label="Email"
                name="email"
                type="email"
                value={user?.email || ''}
            />
            <div className="buttons">
                <Button text="cancel" type="submit" onClick={() => {navigate(-1)}} />
                <Button primary text="confirm" type="submit" />
            </div>

        </Form>
    );
}

export default AccountFound;
